import script from "./QueueDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./QueueDashboard.vue?vue&type=script&setup=true&lang=js"

import "./QueueDashboard.vue?vue&type=style&index=0&id=04096230&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04096230"]])

export default __exports__